import { UserOutlined , CalendarOutlined, DownloadOutlined, FundViewOutlined, InteractionOutlined, LogoutOutlined, PlusOutlined, SettingOutlined } from '@ant-design/icons';
import { Popover, Tooltip } from 'antd';
import { FC, ReactNode, useState } from 'react';
import { LoginPage } from '../pages/login';
import { getUsername, hasFR, hasImu, hasOnlyImu, hasQA, hasTracks, hasUSA, isAdmin, isViewer } from '../services/auth.header';
import { useAuthContext } from '../services/auth.service';
import './layout.scss';
import { getversion } from '../version';
/* -------------------------------------------------------------------------------- *\
|                               LayoutSite
\* -------------------------------------------------------------------------------- */
export const LayoutSite: FC<{ children?: ReactNode }> = (children) =>
{
	var auth = useAuthContext();
	const isadmin = isAdmin();
	// viewer: calendar and week only
	const viewer = isViewer();
	const withUSA = !viewer && hasUSA();
	const withFR = !viewer && hasFR();
	const withTracks = !viewer && hasTracks();
	const withQA = !viewer && hasQA();
	const withIMU = !viewer && hasImu();
	const withOnlyIMU = hasOnlyImu();
	const version = getversion();
	const username = getUsername();

	const [route] = useState<string>(window.location.pathname);
	/* -------------------------------------------------------------------------------- *\
	|                               isactive
	\* -------------------------------------------------------------------------------- */
	function isactive(path: string) : boolean
	{
		return route === path;
	}	
	if (!auth || !auth.token)
	{
		return <LoginPage />
	}

	return (
		<div className="layout">
			<div className="layout__sider" >
				<div className="layout__logo">
					<a href="/" ><img src={'/images/logo.png'} alt="McLloyd" /></a>
				</div>
				<Tooltip title={username} placement='right' color={'#888888'}><div className="layout__username"><UserOutlined />{username}</div></Tooltip>
				<div className="layout__menucont">
					<div className="layout__menu">
						{
							!withOnlyIMU &&
							<Tooltip title="Calendar" placement='right' color={'#888888'}><a className={'layout__menu__item' + (isactive('/') ? ' layout__menu__item__active' : '')} href="/" ><FundViewOutlined /></a></Tooltip>
						}
						{
							!withOnlyIMU &&
							<Tooltip title="Week" placement='right' color={'#888888'}><a className={'layout__menu__item' + (isactive('/week') ? ' layout__menu__item__active' : '')} href="/week" ><CalendarOutlined /></a></Tooltip>
						}
						{
							(withFR || withUSA || withQA) &&
							<Popover
								placement="right"
								trigger="hover"
								styles={{ body: { padding: 0, background: 'black', border: '1px solid #333' } }}
								style={{ paddingLeft: 4 }}
								arrow={false}
								content={
									<div className="layout__submenu">
										<a className={'layout__menu__item' + (isactive('/newrace') ? ' layout__menu__item__active' : '')} href="/newrace">
											<p className='layout__menu__item__text'>New</p>
											<PlusOutlined style={{ fontSize: "20px" }} />
										</a>
										<div style={{ borderTop: '1px solid #333', margin: '4px 0' }} />
										{
											withFR &&
											<Tooltip title="Import race from JSON" placement='right' color={'#888888'}>
												<a className={'layout__menu__item' + (isactive('/import') ? ' layout__menu__item__active' : '')} href="/import">
													<p className='layout__menu__item__text'>FR</p>
													<DownloadOutlined style={{ fontSize: "24px" }}/>
												</a>
											</Tooltip>
										}
										{
											withUSA &&
											<Tooltip title="Import race from XML USA file" placement='right' color={'#888888'}>
												<a className={'layout__menu__item' + (isactive('/importus') ? ' layout__menu__item__active' : '')} href="/importus">
													<p className='layout__menu__item__text'>USA</p>
													<DownloadOutlined style={{ fontSize: "24px" }} />
												</a>
											</Tooltip>
										}
										{
											withQA &&
											<Tooltip title="Import race from XML QA file" placement='right' color={'#888888'}>
												<a className={'layout__menu__item' + (isactive('/importqa') ? ' layout__menu__item__active' : '')} href="/importqa">
													<p className='layout__menu__item__text'>QA</p>
													<DownloadOutlined style={{ fontSize: "24px" }} />
												</a>
											</Tooltip>
										}
									</div>
								}
							>
								<div className={'layout__menu__item' + (['/import', '/importus', '/importqa', '/newrace'].includes(route) ? ' layout__menu__item__active' : '')}>
									<DownloadOutlined style={{ fontSize: "24px" }} />
								</div>
							</Popover>
						}
						{
							withTracks &&
							<>
								<Tooltip title="Tracks" placement='right' color={'#888888'}><a className={'layout__menu__item' + (isactive('/tracks') ? ' layout__menu__item__active' : '')} href="/tracks"><img src={'/images/tracks.svg'} alt="Tracks" /></a></Tooltip>
								<Tooltip title="Edit track" placement='right' color={'#888888'}><a className={'layout__menu__item' + (isactive('/edittrack') ? ' layout__menu__item__active' : '')} href="/edittrack"><img src={'/images/edittrack.svg'} alt="Edit track" /></a></Tooltip>
							</>
						}
						{
							isadmin &&
							<>
								<Tooltip title="Events GNET" placement='right' color={'#888888'}>
									<a className={'layout__menu__item' + (isactive('/eventsgnet') ? ' layout__menu__item__active' : '')} href="/eventsgnet">
										<p className='layout__menu__item__textsmall'>GNET</p>
										<InteractionOutlined style={{ fontSize: "24px" }}/>
									</a>
								</Tooltip>
								<Tooltip title="Events" placement='right' color={'#888888'}>
									<a className={'layout__menu__item' + (isactive('/events') ? ' layout__menu__item__active' : '')} href="/events">
										<p className='layout__menu__item__textsmall'>ALL</p>
										<InteractionOutlined style={{ fontSize: "24px" }}/>
									</a>
								</Tooltip>
							</>
						}
						{
							withIMU &&
							<Tooltip title="IMU" placement='right' color={'#888888'}>
								<a className={'layout__menu__item' + (isactive('/imu') ? ' layout__menu__item__active' : '')} href="/imu">
									<p className='layout__menu__item__textsmall'>IMU</p>
									<InteractionOutlined style={{ fontSize: "24px" }}/>
								</a>
							</Tooltip>
						}
					</div>
					<div className="layout__menu layout__menu__bottom">
						{
							isadmin &&
							<Tooltip title="Settings" placement='right' color={'#888888'}><a className={'layout__menu__item' + (isactive('/settings') ? ' layout__menu__item__active' : '')} href="/settings"><SettingOutlined /></a></Tooltip>
						}
						<Tooltip title="Logout" placement='right' color={'#888888'}><div className='layout__menu__item' onClick={() => auth.logout()}><LogoutOutlined /></div></Tooltip>
					</div>
				</div>
			</div>
			<div className="layout__content">
				<div className="layout__content__inner">
					<div>{children.children}</div>
				</div>
				<div className="layout__footer">{version}</div>
			</div>
	  </div>
	  );
}
